import {
  DisplayRecommendation,
  type Tax,
} from 'src/App/generated/graphql-types';
import type { MappedPrice } from 'src/mappers/mapAdProductPrice';

const isNetPriceEqualToRetailPrice = (price: MappedPrice): boolean =>
  price.netPrice.value === price.retailPrice.value;

const isTaxInclusive = (tax?: Tax): tax is Tax =>
  tax?.displayRecommendation === DisplayRecommendation.INCLUSIVE;

const getRetailTax = (price: MappedPrice): number =>
  isTaxInclusive(price.retailTax) ? (price.retailTax?.amount.value ?? 0) : 0;

const getTax = (price: MappedPrice): number =>
  isTaxInclusive(price.tax) ? (price.tax?.amount.value ?? 0) : 0;

const getNetPrice = (price: MappedPrice): number => price.netPrice.value;

const getRetailPrice = (price: MappedPrice): number => price.retailPrice.value;

const getPriceWithTax = (
  price: MappedPrice,
  showDiscountInfo: boolean,
): number =>
  showDiscountInfo
    ? getNetPrice(price) + getTax(price)
    : getRetailPrice(price) + getRetailTax(price);

const getPriceBeforeDiscountWithTax = (price: MappedPrice): number =>
  getRetailPrice(price) + getRetailTax(price);

export {
  isNetPriceEqualToRetailPrice,
  getPriceBeforeDiscountWithTax,
  getPriceWithTax,
};
